// import persist from './persist'
import axios from 'axios'
// import { NotUnique } from '../errors/bucketErrors'
// import { axapi } from '../helpers/axinstance'
// import router from '../router/index'

export default {
  state: {
    bucketHosts: [],
    bucketHostUsers: [],
    bucketHostPolicies: [],
    defaultBucketHostUser: {
      name: '',
      display_text: '',
      access_key: '',
      secret_key: '',
      fk_bucket_host_key: 0,
      fk_organization_key: 0,
      fk_bucket_host_policy_key: 0,
      is_enabled: true,
    },
    defaultBucketHostPolicy: {
      name: '',
      display_text: '',
      value: '',
      bucket_host_key: 0,
      organization_key: 0,
    },
  },
  mutations: {
    PERSIST_BUCKET_HOSTS (state, payload) {
      state.bucketHosts = payload
    },
    PERSIST_BUCKET_HOST_USERS (state, payload) {
      state.bucketHostUsers = payload
    },
    PERSIST_BUCKET_HOST_POLICIES (state, payload) {
      state.bucketHostPolicies = payload
    },
  },
  actions: {
    // Bucket Host
    async getBucketHost ({ dispatch, commit, rootState }, payload) {
      try {
        const response = await axios.get(process.env.VUE_APP_API_URL + `/api/v1/bucket-host/${payload.bucket_host_key}/?organization_key=${payload.organization_key}`)
        console.log(response)
        // commit('PERSIST_BUCKET_HOSTS', response.data)
        return response.data
      } catch (e) {
        // commit('PERSIST_BUCKET_HOSTS', [])
        await dispatch('processAxiosError', e)
        return {}
      }
    },
    async getBucketHosts ({ dispatch, commit, rootState, state }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.get(process.env.VUE_APP_API_URL + `/api/v1/bucket-host?organization_key=${payload}`)
        // console.log(response)
        // console.log(state)
        // commit('PERSIST_BUCKET_HOSTS', response.data)
        state.bucketHosts = response.data
        return response.data
      } catch (e) {
        state.bucketHosts = []
        // commit('PERSIST_BUCKET_HOSTS', [])
        throw await dispatch('processAxiosError', e)
      }
    },
    async createBucketHost ({ dispatch, commit, rootState }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.get(process.env.VUE_APP_API_URL + `/api/v1/bucket-host/${payload}/`)
        // console.log(response)
        return response.data
      } catch (e) {
        throw await dispatch('processAxiosError', e)
      }
    },
    // BucketHostUsers
    async getBucketUsers ({ dispatch, commit, rootState, state }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.get(process.env.VUE_APP_API_URL + `/api/v1/bucket-user?fk_organization_key=${payload.organization_key}&fk_bucket_host_key=${payload.bucket_host_key}`)
        // console.log(response)
        state.bucketHostUsers = response.data
        // commit('PERSIST_BUCKET_HOST_USERS', response.data)
        return response.data
      } catch (e) {
        state.bucketHostUsers = []
        // commit('PERSIST_BUCKET_HOST_USERS', [])
        throw await dispatch('processAxiosError', e)
      }
    },
    async createBucketUser ({ dispatch, commit, rootState }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.post(process.env.VUE_APP_API_URL + '/api/v1/bucket-user', payload)
        console.log(response)
        // commit('PERSIST_BUCKET_HOST_USERS', response.data)
        return response.data
      } catch (error) {
        // commit('PERSIST_BUCKET_HOST_USERS', [])
        throw await dispatch('processAxiosError', error)
      }
    },
    async updateBucketUser ({ dispatch, commit, rootState }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/bucket-user/${payload.rowkey}`, payload)
        console.log(response)
        // commit('PERSIST_BUCKET_HOST_USERS', response.data)
        return response.data
      } catch (error) {
        // commit('PERSIST_BUCKET_HOST_USERS', [])
        throw await dispatch('processAxiosError', error)
      }
    },
    // BucketHostPolicies
    async getBucketHostPolicies ({ dispatch, commit, rootState, state }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.get(process.env.VUE_APP_API_URL + `/api/v1/bucket-host-policy?organization_key=${payload.organization_key}&bucket_host_key=${payload.bucket_host_key}`)
        console.log(response)
        state.bucketHostPolicies = response.data
        // await commit('PERSIST_BUCKET_HOST_POLICIES', response.data)
        return response.data
      } catch (e) {
        state.bucketHostPolicies = []
        // commit('PERSIST_BUCKET_HOST_POLICIES', [])
        throw await dispatch('processAxiosError', e)
      }
    },
    async createBucketHostPolicy ({ dispatch, commit, rootState }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.post(process.env.VUE_APP_API_URL + '/api/v1/bucket-host-policy', payload)
        console.log(response)
        // commit('PERSIST_BUCKET_HOST_USERS', response.data)
        return response.data
      } catch (error) {
        // commit('PERSIST_BUCKET_HOST_USERS', [])
        throw await dispatch('processAxiosError', error)
      }
    },
    async updateBucketHostPolicy ({ dispatch, commit, rootState }, payload) {
      try {
        // console.log(axios.headers)
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/bucket-host-policy/${payload.rowkey}`, payload)
        console.log(response)
        // commit('PERSIST_BUCKET_HOST_USERS', response.data)
        return response.data
      } catch (error) {
        // commit('PERSIST_BUCKET_HOST_USERS', [])
        throw await dispatch('processAxiosError', error)
      }
    },
  },
  getters: {
    bucketHosts: state => state.bucketHosts,
    bucketHostUsers: state => state.bucketHostUsers,
    bucketHostPolicies: state => state.bucketHostPolicies,
    defaultBucketHostUser: state => state.defaultBucketHostUser,
    defaultBucketHostPolicy: state => state.defaultBucketHostPolicy,
  },
  // plugins: [persist.plugin],
}
